import { homeTranslations } from '@pages/Home/translations';
import { authTranslations } from '@pages/Auth/translations';
import { brandsTranslations } from '@pages/Brands/translations';
import { editBrandTranslations } from '@pages/EditBrand/translations';
import { pointsTranslations } from '@pages/Points/translations';
import { editPointTranslations } from '@pages/EditPoint/translations';
import { productsTranslations } from '@pages/Products/translations';
import { editProductTranslations } from '@pages/EditProduct/translations';
import { profileTranslations } from '@pages/Profile/translations';
import { cataloguesTranslations } from '@pages/Catalogues/translations';
import { editCatalogueTranslations } from '@pages/EditCatalogue/translations';
import { navbarTranslations } from '@components/Core/Navbar/translations';
import { appLoaderTranslations } from '@components/Core/AppLoader/translations';
import { statusBadgeTranslations } from '@components/Core/StatusBadge/translations';
import { brandTabsTranslations } from '@components/Core/BrandTabs/translations';
import { noResultsTranslations } from '@components/Core/NoResults/translations';
import { brandFormPopupsTranslations } from '@components/BrandFormPopups/translations';
import { verificationCodeFormTranslations } from '@forms/VerificationCodeForm/translations';
import { loginFormTranslations } from '@forms/LoginForm/translations';
import { finishRegistrationFormTranslations } from '@forms/FinishRegistrationForm/translations';
import { brandFormTranslations } from '@forms/BrandForm/translations';
import { pointFormTranslations } from '@forms/PointForm/translations';
import { productFormTranslations } from '@forms/ProductForm/translations';
import { profileFormTranslations } from '@forms/ProfileForm/translations';
import { brandsTableTranslations } from '@tables/BrandsTable/translations';
import { catalogueFormTranslations } from '@forms/CatalogueForm/translations';
import { pointsTableTranslations } from '@tables/PointsTable/translations';
import { productsTableTranslations } from '@tables/ProductsTable/translations';
import { cataloguesTableTranslations } from '@tables/CataloguesTable/translations';
import { markersPopupTranslations } from '@popups/MarkersPopup/translations';
import { statusPopupTranslations } from '@popups/StatusPopup/translations';
import { confirmationPopupTranslations } from '@popups/ConfirmationPopup/translations';
import { deleteAccountPopupTranslations } from '@popups/DeleteAccountPopup/translations';
import { changeProfileNamePopupTranslations } from '@popups/ChangeProfileNamePopup/translations';
import { changeProfileEmailPopupTranslations } from '@popups/ChangeProfileEmailPopup/translations';
import { uploadCSVPopupTranslations } from '@popups/UploadCSVPopup/translations';
import { uploadInputTranslations } from '@inputs/UploadInput/translations';
import { uploadJSONInputTranslations } from '@inputs/UploadJSONInput/translations';
import { useValidationTranslations } from '@hooks/useValidation';

export const translations = [
  navbarTranslations,
  appLoaderTranslations,
  authTranslations,
  loginFormTranslations,
  verificationCodeFormTranslations,
  finishRegistrationFormTranslations,
  statusBadgeTranslations,
  brandsTranslations,
  brandsTableTranslations,
  statusPopupTranslations,
  brandFormTranslations,
  uploadInputTranslations,
  markersPopupTranslations,
  confirmationPopupTranslations,
  editBrandTranslations,
  homeTranslations,
  pointsTranslations,
  brandTabsTranslations,
  pointsTableTranslations,
  pointFormTranslations,
  editPointTranslations,
  productsTranslations,
  productsTableTranslations,
  productFormTranslations,
  editProductTranslations,
  profileTranslations,
  profileFormTranslations,
  noResultsTranslations,
  deleteAccountPopupTranslations,
  changeProfileNamePopupTranslations,
  changeProfileEmailPopupTranslations,
  uploadCSVPopupTranslations,
  brandFormPopupsTranslations,
  cataloguesTranslations,
  cataloguesTableTranslations,
  catalogueFormTranslations,
  uploadJSONInputTranslations,
  editCatalogueTranslations,
  useValidationTranslations,
];
